// extracted by mini-css-extract-plugin
export var aircallIframe = "_d8-3";
export var fabContainer = "_d8-5";
export var fabRinging = "_d8-6";
export var loadingOverlay = "_d8-4";
export var pulse = "_d8-7";
export var widgetContent = "_d8-2";
export var widgetPanel = "_d8-0";
export var widgetPanelExpanded = "_d8-1";